import { DialogContent, DialogContentText } from "@mui/material";
import React, { useEffect, useState } from "react";
import useStyles from "../../../components/common/model/styles";

import Popup from "../../../components/common/model/Popup";
import closeIcon from "../../../assets/closeModel.png";
import checkedIcon from "../../../assets/images/actionIcon/print.png";
import JobSummary from "./JobSummary";
import JobSurveyItems from "./JobSurveyItems";
import { useDispatch } from "react-redux";
import {
  getAllSurveyedItemsAction,
  getAllSurveyedSummaryAction,
  setAllSurveyedItemsAction,
  setAllSurveyedSummaryAction,
} from "../../../store/reducers/leadSurveySlice";
import { useSelector } from "react-redux";
import BoxCollection from "./BoxCollection";
import FragilePack from "./FragilePack";
import StorageJob from "./StorageJob";
import StorageJobPrint from "./StorageJobPrint";
import WagesOffSheet from "./WagesOffSheet";
import { jobPrintAction } from "../../../store/reducers/workDiarySlice";
import BoxPrint from "./BoxPrint";
import NewJobSheet from "./NewJobSheet";
import ResidenceContetSheet from "./ResidenceContetSheet";
import FullPackCheckSheet from "./FullPackCheckSheet";
import LoadDataJobSheet from "./LoadDataJobSheet";
import IntoStoreJobSheet from "./IntoStoreJobSheet";

interface ManageJobViewProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  surveyId?: string | undefined | null; // Define the 'generateId' prop
  jobViewType?: string;
  wageSheetData?: any;
}

const ManageJobView: React.FC<ManageJobViewProps> = (props) => {
  const { open, title, onHide, surveyId, jobViewType, wageSheetData } = props;
  const classes = useStyles();
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { surveyedSummary } = useSelector((state: any) => state.leadSurvey);
  const [selectedLeadDetails, setSelectedLeadDetails] = useState(null);
  const [selectedLeadSurvey, setSelectedLeadSurvey] = useState(null);
  const hideHandler = () => {
    onHide();
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (
      open &&
      jobViewType !== "WAGES" &&
      jobViewType !== "RESIDENCE_CONTENT" &&
      jobViewType !== "FULL_PACK" &&
      jobViewType !== "PACKING_CHECK_SHEET" &&
      jobViewType !== "LOAD_DATE_JOB_SHEET" &&
      jobViewType !== "INTO_STORE_JOB_SHEET"
    ) {
      dispatch(
        jobPrintAction({
          leadId: leadDetails?.lead?.generated_id || "",
          is_job_sheet_printed:
            jobViewType === "DEFAULT" || jobViewType === "STORAGE_JOB"
              ? true
              : false,
          is_packing_sheet_printed: jobViewType === "MATERIAL" ? true : false,
          is_collection_sheet_printed:
            jobViewType === "BOX_COLLECTION" ? true : false,
          is_bingo_sheet_printed: jobViewType === "STORAGE" ? true : false,
          is_wage_sheet_printed: jobViewType === "WAGES" ? true : false,
        }),
      );
    }
  }, [dispatch, jobViewType, leadDetails?.lead?.generated_id, open]);

  useEffect(() => {
    if (!open) {
      setSelectedLeadDetails(null);
      setSelectedLeadSurvey(null);
      dispatch(setAllSurveyedSummaryAction(null));
      dispatch(setAllSurveyedItemsAction(null));
      return;
    }

    if (surveyId) {
      dispatch(getAllSurveyedSummaryAction(surveyId));
      dispatch(getAllSurveyedItemsAction(surveyId));
    } else {
      setSelectedLeadDetails(null);
      setSelectedLeadSurvey(null);
      dispatch(setAllSurveyedSummaryAction(null));
      dispatch(setAllSurveyedItemsAction(null));
    }
  }, [dispatch, open, surveyId]);

  useEffect(() => {
    if (surveyedSummary) {
      setSelectedLeadDetails(surveyedSummary.lead);
      setSelectedLeadSurvey(surveyedSummary.survey);
    } else {
      setSelectedLeadDetails(null);
      setSelectedLeadSurvey(null);
    }
  }, [surveyedSummary]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    window.print();
  };
  return (
    <>
      <style>
        {`
        @media print {
      .action-icon {
        display: none;
      }
      .deleteicons, 
      .closeicons {
        display: none;
      }
    }
        `}
      </style>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        // fullScreen={true}
        fullWidth={true}
        maxWidth={jobViewType === "WAGES" ? "xl" : "md"}
        popupBg="#fff"
        dialogStyle={{
          width: "100% !important",
          ...(jobViewType === "WAGES"
            ? {
                maxWidth: "1500px",
                minHeight: "90vh",
              }
            : {}),
        }}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={`${classes.deleteicons} action-icon`}
              alt="save"
            />

            <img
              onClick={hideHandler}
              src={closeIcon}
              className={`${classes.closeicons} action-icon`}
              alt="close"
            />
          </>
        }
      >
        <DialogContent
          sx={{
            padding:
              jobViewType === "WAGES"
                ? "8px 16px 12px !important"
                : "0px 20px !important",
            minHeight: jobViewType === "WAGES" ? "80vh" : "auto",
          }}
        >
          <DialogContentText>
            {jobViewType === "BOX_COLLECTION" ? (
              <>
                <BoxCollection />
              </>
            ) : jobViewType === "MATERIAL" || jobViewType === "FULL_PACK" ? (
              <>
                <FragilePack jobViewType={jobViewType} />
              </>
            ) : jobViewType === "STORAGE_JOB" ? (
              <>
                <StorageJob />
              </>
            ) : jobViewType === "STORAGE" ? (
              <>
                <StorageJobPrint />
              </>
            ) : jobViewType === "WAGES" ? (
              <>
                <WagesOffSheet wageSheetData={wageSheetData} />
              </>
            ) : jobViewType === "BOX_PRINT" ? (
              <>
                <BoxPrint />
              </>
            ) : jobViewType === "RESIDENCE_CONTENT" ? (
              <>
                <ResidenceContetSheet />
              </>
            ) : jobViewType === "PACKING_CHECK_SHEET" ? (
              <>
                <FullPackCheckSheet />
              </>
            ) : jobViewType === "LOAD_DATE_JOB_SHEET" ? (
              <>
                <LoadDataJobSheet />
              </>
            ) : jobViewType === "INTO_STORE_JOB_SHEET" ? (
              <>
                <IntoStoreJobSheet />
              </>
            ) : (
              <>
                <NewJobSheet />
                {/* <JobSummary
                  selectedLeadDetails={selectedLeadDetails}
                  selectedLeadSurvey={selectedLeadSurvey}
                />

                <JobSurveyItems /> */}
              </>
            )}
          </DialogContentText>
        </DialogContent>
      </Popup>
    </>
  );
};

export default ManageJobView;
